import { Component } from "react";
import { useLocation } from "react-router-dom";

class PageErrorBoundary extends Component {
  state = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.resetKey) {
      return { failed: false, resetKey: props.resetKey };
    }
    return null;
  }

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <section className="mx-auto my-12 w-full max-w-lg px-6 text-left" role="alert">
        <div className="panel p-6">
          <h1 className="text-lg font-semibold text-theme">Unable to load this page</h1>
          <p className="mt-2 text-sm text-theme-secondary">
            The portal may have been updated, or the connection may have been interrupted.
            Check your connection and reload the page. You can also use the navigation above
            to open another page.
          </p>
          {/* A full reload fetches the current build; retrying a rejected lazy import does not. */}
          <a
            href={this.props.reloadHref}
            className="mt-5 inline-flex rounded-lg bg-brand-deep px-4 py-2 text-sm font-semibold text-white no-underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            Reload page
          </a>
        </div>
      </section>
    );
  }
}

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return (
    <PageErrorBoundary
      resetKey={location.key}
      reloadHref={`${location.pathname}${location.search}${location.hash}`}
    >
      {children}
    </PageErrorBoundary>
  );
}
